<template>
    <div>
        <jet-button @click.native.prevent="createLinkToken" v-if="!accounts">Link Your Bank Accounts</jet-button>
        <jet-button @click.native.prevent="createLinkToken" v-if="accounts">Update Your Bank Accounts</jet-button>
    </div>
</template>

<script>
export default {
    name: "Plaid",
    components: {
        JetButton: require("@/Jetstream/Button").default,
    },
    mounted() {
        const script = document.createElement("script")
        script.src = "https://cdn.plaid.com/link/v2/stable/link-initialize.js"
        script.async = true
        document.head.appendChild(script)
        this.plaidScript = script
    },
    beforeDestroy() {
        if (this.plaidScript) {
            document.head.removeChild(this.plaidScript)
        }
    },
    props: ["accounts"],
    data() {
        return {
            form: this.$inertia.form({
                public_token: "",
                accounts: [],
                institution: {},
                link_session_id: "",
                link_token: "",
                _method: "POST",
            }),
        }
    },
    methods: {
        createLinkToken() {
            this.$emit("opened", true)

            fetch("/plaid/create-token", {
                method: "GET",
                headers: {
                    "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
                    Accept: "application/json",
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    const parsedData = JSON.parse(data.data) // Parse the stringified JSON in the data field
                    // console.log("Link Token: " + parsedData.link_token)
                    this.linkPlaidAccount(parsedData.link_token)
                })
                .catch((error) => {
                    console.error("Error creating link token: ", error)
                })
        },

        linkPlaidAccount(linkToken) {
            const linkHandler = Plaid.create({
                token: linkToken,
                onSuccess: (public_token, metadata) => {
                    this.form.public_token = public_token
                    // Populate the form with data from Plaid
                    this.form.accounts = metadata.accounts
                    this.form.institution = metadata.institution
                    this.form.link_session_id = metadata.link_session_id
                    this.form.link_token = linkToken

                    // Inertia form submission
                    this.form.clearErrors()
                    this.form.post("/plaid/store", {
                        preserveScroll: true,
                        onFinish: () => this.$emit("accounts-stored"),
                        onError: (errors) => {
                            if (errors.someSpecificError) {
                                // Handle specific error
                            }
                        },
                    })
                },
                onEvent: (eventName, metadata) => {
                    if (eventName === "OPEN") {
                        this.$emit("close")
                    } else if (eventName === "EXIT") {
                        this.$emit("open")
                    }
                },
            })
            linkHandler.open()
        },
    },
}
</script>
